export default __webpack_public_path__ + "static/media/rotular-gray.32304222.webp";